import React from "react";
import PropTypes from 'prop-types';
import { Button } from "@mui/material";

import AddIcon from '@mui/icons-material/Add';

const AddButton = ({handleAddClick, label, width, disabled, style, variant, ...props}) => (
    <Button
        color="primary" 
        size="small"
        variant={variant || "outlined"}
        startIcon={<AddIcon sx={{ fontSize: '14px !important' }} />}
        onClick={() => handleAddClick()}
        style={{width: width, ...style}}
        disabled={disabled}
        {...props}
        sx={{ '& .MuiButton-startIcon': { mr: '6px' }, ...props.sx }}
    >
        {label || "Добавить"}
    </Button>
)

AddButton.propTypes = {
    handleAddClick: PropTypes.func
};

export default AddButton;
